<template>
	<div class="main">
        <div class="main-title">
            <span class="main-back" @click="goBack"></span>
            <h3>文章管理</h3>
        </div>
        <div class="main-search">
            <form target="frameFile" id="loadDataByTitle">
            	<input type="search" placeholder="搜索全部文章" v-model="searchTxt" @input="hideIcon"/>
				<iframe name='frameFile' style="display: none;"></iframe>
            </form>            
            <span v-if="!hideIconStatus" class="search-icon"></span>
        </div>
        <div class="sec-list">
            <Tab></Tab>
        </div>
    </div>
</template>
<script>
import {dateFormat} from './../common/js/util.js'
	import Tab from './../components/pagearticle/tab.vue'
	export default {
		name: 'RegistType',
		data (){
			return {
				searchTxt: '',
                hideIconStatus: false,
			}
		},
		components: {
			Tab,
		},
		mounted(){

        },
		methods:{
			hideIcon (){
				if(this.searchTxt){
					this.hideIconStatus = true;
				}else{
					this.hideIconStatus = false;
				}
			},
			goBack (){
				this.$router.go(-1);
			},
		},
		filters:{
			dateFormat:function(val){
				if(val){
					return dateFormat('yyyy-MM-dd hh:mm:ss',new Date(val));
				}

			}
		}
	}	
</script>
<style scoped>
	.main{
	    background: #f5f5f5;
	    min-height: 100%;
	    position: relative;
	}
    input::-webkit-input-placeholder {
		color: #999;
	}
	.main-title {
	    position: relative;
	}
	.main-title .main-back{
	    float: left;
	    display: inline-block;
	    width: 0.5rem;
	    height: 0.5rem;
	    background: url('./../assets/img/back-btn.png') no-repeat center center;
	    background-size: 0.45rem 0.45rem;
	    position: absolute;
	    top:  0.2rem;
	    left: 0.1rem;
	}
	.main-title h3{
	    background: #fff;
	    line-height: 0.9rem;
	    font-size: 0.34rem;
	    font-weight: normal;
	    color: #333333;
	    text-align: center;
	}
	.main-search {
	    width: 94%;
	    margin: 0.15rem auto;
	    height: 0.6rem;
	    background: #fff;
	    border-radius: 0.08rem;
	    position: relative;
	}
	.main-search form{
	    width: 100%;
	    height: 100%;
	    position: relative;
	}
	.main-search input{
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    padding: 0.08rem;
	    text-align: center;
	    font-size: 0.3rem;
	}
	.main-search .search-icon{
	    display: inline-block;
	    width: 0.5rem;
	    height: 0.5rem;
	    background: url('./../assets/img/search-icon.jpg') no-repeat center center;
	    background-size: 0.35rem 0.35rem;
	    position: absolute;
	    top: 0.05rem;
	    left: 50%;
	    margin-left: -1.52rem;
	}
	.sec-list {
	    background: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/pages/pagearticlelist.vue